module.exports = __webpack_public_path__ + "static/media/social-acts-header.36e1140e.png";